const sourceVariable = "prov";

export default sourceVariable